<template>
  <div v-if="dashboardData" class="cx-size">
    <div class="cx-grid-head">
      <div class="cx-head-item">
        <img  :src="PictureUri || defaultLogo"
              width="142" height="109"
              class="cx-head-img"
              :class="{ 'cx-head-img-deft': this.PictureUri === '' }"
              alt="Dealership image">
      </div>

      <div class="cx-head-item cx-head-item-top">
        <dashboard-header :dashboardData="dashboardData" />
      </div>

      <div class="cx-head-item ml-4">
        <div class="controls-grid">
          <options-switch :header="$t('Webportal.CX.BMW.Timeframe')"
                          size="sm"
                          direction="vertical"
                          selectedEventName="selected-time-setting-changed"
                          :toolTipIconShow="true"
                          :toolTipText="$t('Webportal.CX.BMW.Timeframe.ToolTip')"
                          :itemData="timeSettingItems" />
          <div>
            <div>
              <span><b>#{{ $t('Webportal.DashboardBMW.NumberOfShops') }}</b></span>
            </div>
            <div class="ytd-lines">
              <span>YTD = {{ dashboardData.NumberOfShopsYTD }}</span><br>
              <span>Current = {{ dashboardData.NumberOfShops }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="cx-head-item rgrid">
        <!-- NPS on hold -->
        <div v-if="!IsBmwMotorrad && false">
          <p class="narrow_05 head-text-recommend">
            {{ $t('Webportal.Dashboard.NPS') }}
            <span v-b-tooltip.right.nofade="toolTipDelay"
                  :title="$t('Webportal.Dashboard.NPS.Tooltip')"
                  class="info-icon-tooltip">
              <font-awesome-icon :icon="['fas', 'info-circle']" />
            </span>
          </p>
          <div class="recommendations-grid">
            <div></div> 
            <doughnut-chart style="width: 4rem; height: 4rem; display: block;"
                            :chartData="getRecommendationChartData()" />
            <div></div>
          </div>
        </div>
        <div v-else></div>
        <div>
          <dashboard-header-kpi :dashboardData="dashboardData"
                                :actualTimeSetting="timeSetting"
                                :showPerformanceIndex="true"
                                :threshold="relevantThresholds[0].threshold" />
          <!-- <small-legend :thresholdData="threshold"
                        mode="bottom"
                        :opacity="false" /> -->
        </div>
      </div>
    </div>

    <dashboard-journey  v-if="!IsBmwMotorrad" 
                        class="cx-journey" 
                        :brand="ActiveBrand"
                        :isSmall="isSmall" />

    <!-- BMW and MINI -->
    <div v-if="!IsBmwMotorrad">
      <div class="alt-grid">
        <div class="alt-ex aex">
          <b-overlay  :show="!AnyApiActive"
                      variant='light'
                      opacity=0.5
                      blur="4px"
                      rounded="sm">
            <ExplorationCard  :LocationName="dashboardData.Name"
                              :ExplorationScore="dashboardData.ExplorationScore"
                              :GoogleData="dashboardData.Exploration.Google"
                              :SeobilityData="dashboardData.Exploration.Seobility"
                              :AutoscoutData="dashboardData.Exploration.AutoScout"
                              :FacebookData="dashboardData.Exploration.Facebook"
                              :MobileData="dashboardData.Exploration.Mobile"
                              :AutocasionData="dashboardData.Exploration.Autocasion"
                              :MarktplaatsData="dashboardData.Exploration.Marktplaats"
                              :ExplorationAugmentionData="dashboardData.ExplorationAugmention"
                              :colorRange="relevantThresholds[0].threshold"
                              :isSmall="isSmall"
                              :showBadges="showBadges" />
            <template #overlay>
              <overlay-place-holder />
            </template>
          </b-overlay>
        </div>
        <div class="alt-it it1">
          <kpi-collection-empty :primaryKpi="getKpi('1. Contact')"
                                :primaryKpiYTD="getKpiYTD('1. Contact')"
                                fallbackText="1. Contact"
                                :isSmall="isSmall"
                                :actualTimeSetting="timeSetting"
                                :thresholdData="relevantThresholds[0].threshold">
            <kpi-spacer :size="isSmall ? 0.5 : 2" />

            <kpi-head-text  v-if="activeKpi('My BMW/MINI App')"
                            :kpi="activeKpi('My BMW/MINI App')"
                            :isSmall="isSmall"
                            :isSecondary="true">
            </kpi-head-text>

            <kpi-value-item v-if="activeKpi('My BMW/MINI App')"
                            :thresholdData="relevantThresholds[1].threshold"
                            :isSmall="isSmall"
                            :round="true"
                            :kpi="activeKpi('My BMW/MINI App')">
            </kpi-value-item>

            <kpi-spacer :size="0.5" v-if="activeKpi('My BMW/MINI App')" />

            <kpi-head-text  :kpi="activeKpi('Lead FU (total)')"
                            :isSmall="isSmall"
                            :isSecondary="true">
            </kpi-head-text>

            <kpi-value-item :thresholdData="relevantThresholds[2].threshold"
                            :isSmall="isSmall"
                            :round="true"
                            :kpi="activeKpi('Lead FU (total)')">
            </kpi-value-item>
          </kpi-collection-empty>
        </div>
        <div class="alt-it it2">
          <div class="xev" :class="{ 'xev-lg': !isSmall, 'xev-sm': isSmall }">
            <div class="xev-center">
              <kpi-head-text  :kpi="activeKpiGroup('xEV Readiness')"
                              fallbackText="xEV Readiness"
                              :isSmall="isSmall"
                              :isSecondary="false">
              </kpi-head-text>

              <kpi-value-item :thresholdData="relevantThresholds[1].threshold"
                              :round="true"
                              :isSmall="isSmall"
                              :kpi="activeKpiGroup('xEV Readiness')">
              </kpi-value-item>
            </div>
          </div>
          <kpi-collection :primaryKpi="getKpi('2. Sales Consultation')"
                          :primaryKpiYTD="getKpiYTD('2. Sales Consultation')"
                          fallbackText="2. Sales Consultation"
                          :isSmall="isSmall"
                          :actualTimeSetting="timeSetting"
                          :thresholdData="relevantThresholds[0].threshold" />
        </div>
        <div class="alt-it it3">
          <kpi-collection :primaryKpi="getKpi('3. Test Drive')"
                          :primaryKpiYTD="getKpiYTD('3. Test Drive')"
                          fallbackText="3. Test Drive"
                          :isSmall="isSmall"
                          :overlap="true"
                          :secondaryKpi="getKpiGroup('Legendary Moment: Test Drive')"
                          :secondaryKpiYTD="getKpiGroupYTD('Legendary Moment: Test Drive')"
                          :secondaryKpiItems="getKpisFromGroup('Legendary Moment: Test Drive')"
                          :secondaryKpiItemsYTD="getKpisFromGroupYTD('Legendary Moment: Test Drive')"
                          :actualTimeSetting="timeSetting"
                          :showBowl="true"
                          :thresholdData="relevantThresholds[0].threshold"
                          :thresholdDataSecondary="relevantThresholds[1].threshold" />
        </div>
        <div class="alt-it it4">
          <kpi-collection :primaryKpi="getKpi('4. Offer')"
                          :primaryKpiYTD="getKpiYTD('4. Offer')"
                          fallbackText="4. Offer"
                          :isSmall="isSmall"
                          :overlap="true"
                          :secondaryKpi="getKpiGroup('Legendary Moment: Integrated offer')"
                          :secondaryKpiYTD="getKpiGroupYTD('Legendary Moment: Integrated offer')"
                          :secondaryKpiItems="getKpisFromGroup('Legendary Moment: Integrated offer')"
                          :secondaryKpiItemsYTD="getKpisFromGroupYTD('Legendary Moment: Integrated offer')"
                          :actualTimeSetting="timeSetting"
                          :showBowl="true"
                          :thresholdData="relevantThresholds[0].threshold"
                          :thresholdDataSecondary="relevantThresholds[1].threshold" />
        </div>
        <div class="alt-it it5">
          <kpi-collection :primaryKpi="getKpi('5. Contact Care')"
                          :primaryKpiYTD="getKpiYTD('5. Contact Care')"
                          fallbackText="5. Contact Care"
                          :isSmall="isSmall"
                          :secondaryKpi="getKpi('Appointment FU')"
                          :secondaryKpiYTD="getKpiYTD('Appointment FU')"
                          :actualTimeSetting="timeSetting"
                          :thresholdData="relevantThresholds[0].threshold"
                          :thresholdDataSecondary="relevantThresholds[2].threshold" />
        </div>
        <div class="alt-am aam">
          <b-overlay  :show="!AnyApiActive"
                      variant='light'
                      opacity=0.5
                      blur="4px"
                      rounded="sm">
            <ActionManagementCard :dashboardData="dashboardData"
                                  :isSmall="isSmall"
                                  :threshold="relevantThresholds[0].threshold" />
            <template #overlay>
              <overlay-place-holder />
            </template>
          </b-overlay>
        </div>
      </div>
      <div class="legend-container">
        <!-- <div class="legend-threshold" v-for="(item, index) of relevantThresholds"> -->
          <legend-control :thresholds="relevantThresholds[0].threshold" 
                          :isBMW2020="false"
                          :isWide="true"
                          :showTextItems="false" />
          <legend-control :leadFuThresholds="relevantThresholds[2].threshold"
                          :isBMW2020="false"
                          :isWide="true"
                          :showTextItems="false" />
          <legend-control :lmThresholds="relevantThresholds[1].threshold" 
                          :isBMW2020="false"
                          :isWide="true"
                          :showTextItems="false" />
          <legend-control :thresholds="relevantThresholds[3].threshold" 
                          :subTitleText="relevantThresholds[3].subTitle"
                          :isBMW2020="false"
                          :isWide="true"
                          :showTextItems="false" />
      </div>
    </div>

    <!-- BMW Motorrad -->
    <div v-else>
      <div class="alt-grid2">
        <div class="alt-am aex2">
          <b-overlay  :show="!AnyApiActive"
                      variant='light'
                      opacity=0.5
                      blur="4px"
                      rounded="sm">
            <ExplorationCard  :LocationName="dashboardData.Name"
                              :ExplorationScore="dashboardData.ExplorationScore"
                              :GoogleData="dashboardData.Exploration.Google"
                              :SeobilityData="dashboardData.Exploration.Seobility"
                              :AutoscoutData="dashboardData.Exploration.AutoScout"
                              :FacebookData="dashboardData.Exploration.Facebook"
                              :MobileData="dashboardData.Exploration.Mobile"
                              :AutocasionData="dashboardData.Exploration.Autocasion"
                              :MarktplaatsData="dashboardData.Exploration.Marktplaats"
                              :ExplorationAugmentionData="dashboardData.ExplorationAugmention"
                              :colorRange="threshold"
                              :isSmall="isSmall"
                              :showBadges="showBadges" />
            <template #overlay>
              <overlay-place-holder />
            </template>
          </b-overlay>
        </div>

        <div class="alt-it it12" v-for="(item, index) in getBmwMotoGroups()" :key="index">
          <kpi-collection-vertical  :groupName="item.KpiGroupCode"
                                    :dashboardData="dashboardData"
                                    :actualTimeSetting="timeSetting"
                                    :isSmall="isSmall"
                                    :thresholdData="threshold" />
        </div>

        <div class="alt-am aam2">
          <b-overlay  :show="!AnyApiActive"
                      variant='light'
                      opacity=0.5
                      blur="4px"
                      rounded="sm">
            <ActionManagementCard :dashboardData="dashboardData"
                                  :isSmall="isSmall"
                                  :threshold="threshold" />
            <template #overlay>
              <overlay-place-holder />
            </template>
          </b-overlay>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="cx-size">
  </div>
</template>

<script>
import EventBus from "@/services/EventBus.js";
import BuildDataUri from "@/mixins/BuildDataUri";

import ActionManagementCard from "@/components/CX/ActionManagementCard-bmw";
import ExplorationCard from "@/components/CX/ExplorationCard-bmw";
import DashboardHeader from "./DashboardHeader";
import DashboardHeaderKpi from "./DashboardHeaderKPI";
import DashboardJourney from "./DashboardJourney";
import KpiCollection from "./KpiCollection.vue";
import KpiCollectionEmpty from "./KpiCollectionEmpty.vue";
import KpiCollectionVertical from "./KpiCollectionVertical.vue";
import OptionsSwitch from './OptionsSwitch.vue';
import SmallLegend from './SmallLegend.vue';
import OverlayPlaceHolder from './OverlayPlaceHolder.vue';
import DoughnutChart from "@/components/DoughnutChart.vue";

import KpiHeadText from './KpiHeader.vue';
import KpiValueItem from './KpiItem.vue';
import KpiSpacer from './KpiSpacer.vue';

import LegendControl from "@/components/Dashboard-bmw/Year2021/LegendControl.vue";

export default {
  components: {
    ActionManagementCard, ExplorationCard,
    KpiCollection, KpiCollectionVertical, KpiCollectionEmpty,
    DashboardHeader, DashboardHeaderKpi, DashboardJourney,
    DoughnutChart, OptionsSwitch, SmallLegend, OverlayPlaceHolder,
    KpiHeadText, KpiValueItem, KpiSpacer, LegendControl
  },

  mixins: [ BuildDataUri ],

  props: {
    defaultLogo: String,
    dashboardData: {
      type: Object,
      default: () => {}
    },
    dealerInfo: Object,
    selectedTimeframe: {type: String, default: 'ytd' },
    threshold: Array,
    toolTipDelay: { type: Object, default:  () => ({ delay: { "show": 500, "hide": 100 } }) },
    relevantThresholds: { type: Array, required: true }
  },

  data() {
    return {
      KPIGroups: [],
      PictureUri: "",
      selectedScoreId: null,
      isMounted: false,
      showBadges: false,
      isSmall: true,
      timeSetting: 'current', // 'current' or 'ytd'
      timeSettingItems: {
        selected: 'current',
        options: [
          { text: this.$t('Webportal.Dashboard.YTD'), value: 'ytd', disabled: false },
          { text: this.$t('Webportal.CX.Dashboard.Topbar.Current'), value: 'current', disabled: false }
        ]
      }
    };
  },

  computed: {
    AnyApiActive: function() {
      // Filter out "ExplorationActionsToTake" and check if all apis are inactive (negated)
      return !_(this.dashboardData?.Exploration).filter(_.isPlainObject).every('Inactive') ||
        this.dashboardData?.ExplorationAugmention?.Categories?.length > 0;
    },
    ActiveBrand() {
      let activeBrand = this.dashboardData && this.dashboardData.Brand
        ? this.dashboardData.Brand
        : "BMW Motorrad";
      return activeBrand;
    },
    IsBmwMotorrad() {
      return this.ActiveBrand === 'BMW Motorrad';
    }
  },

  watch: {
    dashboardData: {
      immediate: true,
      handler(val, oldVal) {
        // Check if the data is arrived. Needed because immediate is true.
        if (!this.dashboardData.ClientLocationId)
          return;

        this.PictureUri = this.buildDataUriFromGoogle(
          this?.dashboardData?.Pictures
        );

        if (!_.isUndefined(this.dashboardData?.KPI?.KPIGroup)) {
          this.KPIGroups = this.dashboardData.KPI.KPIGroup;
          this.KPIGroups.forEach(group => {
            group.ActionsToTake = 0;
            group.Items = _.filter(
              this.dashboardData.KPI.KPI,
              k => k.GroupCode == group.Code
            );

            group.Items.forEach(kpi => {
              kpi.ShowPopup = false;
              kpi.PopupPosition = {};

              if (!kpi.IsAccomplished) group.ActionsToTake++;
            });
          });
        } else {
          // ???
        }

        // Allow access on Ratings entries by using their name
        _.forEach(this.dashboardData.Exploration, ex => {
          if (typeof ex == "object" && ex.Ratings)
            ex.RatingsByName = _.keyBy(ex.Ratings, "Name");
        });

        // Allow google popup access to full address for map search
        if (this.dashboardData?.Exploration?.Google) {
          this.dashboardData.Exploration.Google.FullAddress = this.dashboardData.Brand ? this.dashboardData.Brand + ', ' : '';
          this.dashboardData.Exploration.Google.FullAddress += this.dashboardData.AllTexts;
        }

        // Set resolved lists, if not present
        this.dashboardData.Exploration.ResolvedApis = this.dashboardData.Exploration.ResolvedApis || [];

        if (this.dashboardData && this.dashboardData.ExplorationAugmention) {
          this.dashboardData.ExplorationAugmention.ResolvedApisFromSurveys = this.dashboardData?.ExplorationAugmention?.ResolvedApisFromSurveys || [];
        }
      }
    }
  },

  mounted() {
    EventBus.$on("selected-time-setting-changed", this.handleSelectedTimeSettingChanged);
  },

  beforeDestroy() {
    EventBus.$off("selected-time-setting-changed", this.handleSelectedTimeSettingChanged);
  },

  methods: {
    getRecommendationChartData() {
      // let kpi = this.dashboardData.KPI.KPI.find(x => x.Code == 'Recommendaton');

      // if (_.isEmpty(kpi) || _.isEmpty(kpi.SurveyWave)) {
      //   return {};
      // }

      // let wave = _.last(kpi.SurveyWave);
      let dataPoints = [
        90, // wave.ResultPromoters,
        5, // 100 - wave.ResultDetractors - wave.ResultPromoters,
        5 //wave.ResultDetractors
      ];

      let result = {
        labels: [
          this.$t('Webportal.DashboardBMW.Promoters'),
          this.$t('Webportal.DashboardBMW.Passives'),
          this.$t('Webportal.DashboardBMW.Detractors')],
        datasets: [
          {
            backgroundColor: [ this.threshold[2].Color, this.threshold[1].Color, this.threshold[0].Color ],
            data: dataPoints
          }
        ]
      };
      return result;
    },
    handleSelectedTimeSettingChanged(event) {
      this.timeSetting = event;
    },
    getKpi(code) {
      return this.dashboardData.KPI.KPI.find(x => x.Code == code);
    },
    getKpiYTD(code) {
      return this.dashboardData.KPI.KPIYTD.find(x => x.Code == code);
    },
    getKpiGroup(code) {
      return this.dashboardData.KPI.KPIGroup.find(x => x.Code == code);
    },
    getKpiGroupYTD(code) {
      return this.dashboardData.KPI.KPIGroupYTD.find(x => x.Code == code);
    },
    getKPIGroups() {
      return this.KPIGroups.filter(x => x.Code !== 'Process Excellence');
    },
    getBmwMotoGroups() {
      return this.dashboardData.ExpectedKpiGroups;
    },
    activeKpi(code) {
      if(this.timeSetting == 'current') {
        return this.getKpi(code);
      } else {
        return this.getKpiYTD(code);
      }
    },
    activeKpiGroup(code) {
      if(this.timeSetting == 'current') {
        return this.getKpiGroup(code);
      } else {
        return this.getKpiGroupYTD(code);
      }
    },
    getKpisFrom(groupItems, groupCode) {
      return groupItems.filter(x => x.GroupCode == groupCode);
    },
    getKpisFromGroup(code) {
      return this.getKpisFrom(this.dashboardData.KPI.KPI, code);
    },
    getKpisFromGroupYTD(code) {
      return this.getKpisFrom(this.dashboardData.KPI.KPIYTD, code);
    }
  }
};
</script>

<style lang="scss">
  @use "@/../scss/bmw/cx.scss";

  .cx-simple-title {
    font-size: 1.1rem !important;
    font-weight: bold;
  }

  .cx-simple-card {
    padding: 0.5rem !important;
  }

</style>

<style lang="scss" scoped>
  @use "@/../scss/bmw/cx.scss";

.legend-container {
  display: flex; 
  flex-direction: row;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.recommendations-grid{
  display: grid;
  grid-template-columns: 1fr auto 1fr;
}

.head-text-recommend {
  font-weight: bold;
  margin-bottom: 4px;
  text-align: center;
  padding: 4px 0px;
  font-size: 1.1em;
}

.xev {
  height: 6rem;
  z-index: 5;
  border-radius: 0.25rem;
  background: cx.$bg-color-light;
  border: 1px solid cx.$bd-color-light;
  position: absolute;
}
.xev-lg{
  margin-top: 7.75rem;
}
.xev-sm {
  margin-top: 6.4rem;
}
.xev-center {
  margin: 0rem auto;
  // width: 50%;
}

@media (min-width: 1600px)  {
  .xev {
    width: calc(25% - 0.25rem);
  }

  .alt-grid {
    display: grid;
    height: 100%;
    grid-template-columns: 3fr 2fr 2fr 2fr 2fr 2fr 3fr;
    grid-template-areas: "aex it1 it2 it3 it4 it5 aam";
    grid-gap: 0.5rem;
    justify-content: stretch;
  }
  .alt-grid2 {
    display: grid;
    height: 100%;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-template-areas: "aex2 . . . . . aam2";
    grid-gap: 0.5rem;
    justify-content: stretch;
  }
}

@media (max-width: 1599px)  {

  .xev {
    width: calc(40% - 0.25rem);
  }

  .alt-grid {
    display: grid;
    height: 100%;
    grid-gap: 0.5rem;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    justify-content: stretch;
  }

  .aex { grid-area: 2 / 1 / 2 / 6; }
  .aam { grid-area: 2 / 6 / 2 / 11; }
  .it1 { grid-area: 1 / 1 / 1 / 3; }
  .it2 { grid-area: 1 / 3 / 1 / 5; }
  .it3 { grid-area: 1 / 5 / 1 / 7; }
  .it4 { grid-area: 1 / 7 / 1 / 9; }
  .it5 { grid-area: 1 / 9 / 1 / 11; }

   .alt-grid2 {
    display: grid;
    height: 100%;
    grid-gap: 0.5rem;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas: "aex aam ."
      ". . .";
    justify-content: stretch;
  }
  // .aex2 { grid-area: 2 / 1 / 2 / 3; }
  // .aam2 { grid-area: 2 / 4 / 2 / 7; }
  // .it12 { grid-area: 1 / 1 / 1 / 3; }
  // .it22 { grid-area: 1 / 3 / 1 / 5; }
  // .it32 { grid-area: 1 / 5 / 1 / 7; }
}


.controls-grid {
  display: grid;
  grid-gap: 2.0rem;
  grid-template-columns: 12rem 8rem;
}
.ytd-lines {
  line-height: 1.1;
}

.cx-journey {
  margin-bottom: 1rem;
}

.cx-grid-head {
  display: grid;
  height: 100%;
  grid-template-columns: auto auto 2fr auto;
  grid-gap: 0.5rem;
  justify-content: stretch;
}

.rgrid {
  display: grid;
  grid-template-columns: 1fr 13.25rem;
  grid-gap: 0.75rem;
}

.cx-head-img-deft {
  object-fit: contain !important;
}

.cx-head-img {
  object-fit: cover;
  border-radius: 8px !important;
}

.cx-size {
  min-height: 600px !important;
}

.cx-head-item-top {
  padding: 1rem;
  padding-top: 0rem !important;
  padding-right: 0rem !important;
}

.tooltip-override ::v-deep .tooltip-inner  {
  max-width: 500px !important;
}

</style>
